import { render, staticRenderFns } from "./ModuleSearch.vue?vue&type=template&id=a35f7856&scoped=true"
import script from "./ModuleSearch.vue?vue&type=script&lang=js"
export * from "./ModuleSearch.vue?vue&type=script&lang=js"
import style0 from "./ModuleSearch.vue?vue&type=style&index=0&id=a35f7856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35f7856",
  null
  
)

export default component.exports